import _ from "lodash";
import {
  Component,
  Fragment,
} from "react";
import {
  Button,
} from "react-bootstrap";

import store from "CommonState/store";
import {
  Awesome,
  EditPanel,
  EditPanelTable,
  formatValue,
  Panel,
  Well,
} from "CommonComponents/bricks";
import {
  createInjectsSelector,
  injectsFromSchemaAndRenderMethods,
} from "CommonCore/schema-util";
import SHKFormTab from "App/shk-form-tab";
import {
  renderChildren,
} from "CommonCore/router-util";

export default function createEigenschaftenEditor(schemaArr, renderMethods, decorators, arrayinfo) {
  const injects = [];
  _.forEach(schemaArr, item => {
    injects.push(...injectsFromSchemaAndRenderMethods(item, renderMethods));
  });

  const selectInjects = createInjectsSelector(injects);

  @store(...injects)
  class Context extends Component {
    get entity() {
      const {
        parentEntity,
      } = this.props;
      return !parentEntity ? [] : _.isArray(parentEntity[arrayinfo.property]) ? parentEntity[arrayinfo.property][0] : [] || [];
    }

    render() {
      const {
        disabled,
        additionalInjects,
        panelName,
        action,
        onChange,
        schema,
        afterCommit,
      } = this.props;

      return <span>
        <EditPanel
          header={<h4 key='h4'>{panelName}</h4>}
          editable={!this.props.readonly}
          unshowSatus={disabled}
          action={action}
          schema={schema || schemaArr[0]}
          injects={_.assign(selectInjects(this.props), additionalInjects)}
          entity={this.entity}
          renderMethods={renderMethods}
          onSave={this.save}
          onChange={onChange}
          afterCommit={afterCommit}
        />
      </span>;
    }

    save = async entity => {
      const {
        onSave,
        parentEntity,
        beforeSave,
      } = this.props;

      entity = _.isFunction(beforeSave) ? beforeSave(entity) : entity;

      if (!entity) {
        return;
      }

      await onSave(parentEntity, entity, arrayinfo);
    };
  }

  let component = Context;
  _.forEach(decorators, d => {
    component = d(component);
  });

  return component;
}

export function createEigenschaftenEditorWithPosition(schemaArr, renderMethods, decorators, arrayinfo) {
  const injects = [];
  _.forEach(schemaArr, item => {
    _.assign(injects, injectsFromSchemaAndRenderMethods(item, renderMethods));
  });

  const collspan = _.filter(schemaArr[0].table, field => !field.hideFromDetail).length + 1;

  const selectInjects = createInjectsSelector(injects);

  @store(...injects)
  class ContextWithPosition extends Component {
    constructor() {
      super();
      this.state = {
        statusNew: false,
      };
    }

    get entity() {
      const {
        parentEntity,
      } = this.props;
      return !parentEntity ? [] : parentEntity[arrayinfo.property] || [];
    }

    render() {
      const {
        disabled,
        additionalInjects,
        panelName,
        panelNameNew,
        panelNamePosition,
        action,
        schema,
        typUniqueField,
        customControls,
        afterCommit,
        topwell,
        bottomwell,
      } = this.props;

      return <span>
        <Panel
          header={<h4 key='h4'>{panelName}</h4>}
        >
          {topwell && <Well>{topwell}</Well>}
          {!disabled && <table className='maxi-detail-table'>
            <tbody>
              {_.sortBy(this.entity, "").map((item, index) => <Fragment key={item[typUniqueField] || index}>
                <tr>
                  {schemaArr[0].renderEditorRow && schemaArr[0].renderEditorRow(item, selectInjects(this.props))}
                  {!schemaArr[0].renderEditorRow && _.filter(schemaArr[0].table, field => !field.hideFromDetail).map((field, index) => <td key={index}>{formatValue(item, field, renderMethods, selectInjects(this.props))}</td>)}
                  {!this.props.readonly &&
                      <td className='text-right'>
                        <Button variant='link' data-id={item[typUniqueField]} onClick={this.getdIdAndToggle}>
                          <Awesome name='pencil-alt' />
                        </Button>
                        <Button variant='link' data-id={item[typUniqueField]} onClick={this.getIdAndDelete}>
                          <Awesome name='trash' />
                        </Button>
                      </td>
                  }
                </tr>
                {this.state[item[typUniqueField]] && <tr>
                  <td colSpan={collspan}>
                    <EditPanelTable
                      header={<h4 key='h4'>{panelNamePosition}</h4>}
                      editable={!this.props.readonly}
                      action={action}
                      schema={schema || schemaArr[0]}
                      injects={_.assign(selectInjects(this.props), additionalInjects)}
                      entity={item}
                      onClose={this.toggleStatus}
                      onSave={this.save}
                      afterCommit={afterCommit}
                      dataId={item[typUniqueField]}
                      customControls={customControls}
                      submitText={this.props.submitText}
                    />
                  </td>
                </tr>}
              </Fragment>)}
              {this.state.statusNew && <tr>
                <td colSpan={collspan}>
                  <EditPanelTable
                    header={<h4 key='h4'>{panelNameNew}</h4>}
                    editable={!this.props.readonly}
                    action={action}
                    schema={schema || schemaArr[0]}
                    injects={_.assign(selectInjects(this.props), additionalInjects)}
                    entity={{}}
                    onClose={this.toggleStatus}
                    onSave={this.save}
                    afterCommit={afterCommit}
                    customControls={customControls}
                    submitText={this.props.submitText}
                  />
                </td>
              </tr>}
            </tbody>
          </table>}
          {!this.props.readonly && !disabled && !this.state.statusNew && <Button variant='outline-primary' className='w-100' block onClick={this.getdIdAndToggle}>
            <Awesome name='plus' />&nbsp;Position hinzufügen
          </Button>}
          {bottomwell && <span><br /><Well>{bottomwell}</Well></span>}
          {renderChildren(this.props)}
        </Panel>
      </span>;
    }

    getIdAndDelete = ({ currentTarget }) => {
      const id = currentTarget.getAttribute("data-id");
      this.delete(id);
    };

    delete = async id => {
      const {
        parentEntity,
        afterCommit,
      } = this.props;

      let array = parentEntity[arrayinfo.property] || [];
      array = array.filter(x => x[arrayinfo.id] != id);
      if (_.isEmpty(array)) {
        array = null;
      }
      parentEntity[arrayinfo.property] = array;

      await this.save({});
      afterCommit && afterCommit();
    };

    getdIdAndToggle = ({ currentTarget }) => {
      const id = currentTarget.getAttribute("data-id");
      this.toggleStatus(id);
    };

    toggleStatus = id => {
      if (id) {
        this.setState({ [id]: !this.state[id] });
      } else {
        this.setState({ statusNew: !this.state.statusNew });
      }
    };

    save = async entity => {
      const {
        onSave,
        afterSave,
        parentEntity,
        beforeSave,
      } = this.props;

      entity = _.isFunction(beforeSave) ? beforeSave(entity) : entity;

      if (!entity) {
        return;
      }

      await onSave(parentEntity, entity, arrayinfo);
      afterSave && afterSave(entity);
    };
  }

  let component = ContextWithPosition;
  _.forEach(decorators, d => {
    component = d(component);
  });

  return component;
}

export function createSHKEditorWithPosition(schemaArr, renderMethods, decorators, arrayinfo) {
  const injects = [];
  _.forEach(schemaArr, item => {
    _.assign(injects, injectsFromSchemaAndRenderMethods(item, renderMethods));
  });

  const collspan = _.filter(schemaArr[0].table, field => !field.hideFromDetail).length + 1;

  const selectInjects = createInjectsSelector(injects);

  @store(...injects)
  class ContextWithPosition extends Component {
    constructor() {
      super();
      this.state = {
        statusNew: false,
      };
    }

    get entity() {
      const {
        parentEntity,
      } = this.props;
      return !parentEntity ? [] : parentEntity[arrayinfo.property] || [];
    }

    render() {
      const {
        disabled,
        panelName,
        typUniqueField,
        subpanels,
      } = this.props;

      return <span>
        <Panel
          header={<h4 key='h4'>{panelName}</h4>}
        >
          {!disabled && <table className='maxi-detail-table'>
            <tbody>
              {_.sortBy(this.entity, "").map((item, index) => <Fragment key={item[typUniqueField] || index}>
                <tr>
                  {schemaArr[0].renderEditorRow && schemaArr[0].renderEditorRow(item, selectInjects(this.props))}
                  {!schemaArr[0].renderEditorRow && _.filter(schemaArr[0].table, field => !field.hideFromDetail).map((field, index) => <td key={index}>{formatValue(item, field, renderMethods, selectInjects(this.props))}</td>)}
                  {!this.props.readonly &&
                      <td className='text-right'>
                        <Button variant='link' data-id={item[typUniqueField]} onClick={this.getdIdAndToggle}>
                          <Awesome name='pencil-alt' />
                        </Button>
                        <Button variant='link' data-id={item[typUniqueField]} onClick={this.getIdAndDelete}>
                          <Awesome name='trash' />
                        </Button>
                      </td>
                  }
                </tr>
                {this.state[item[typUniqueField]] && <tr>
                  <td colSpan={collspan}>
                    <SHKFormTab
                      dataId={item[typUniqueField]} editPanel={subpanels[0]} onClose={this.toggleStatus}
                      onSave={this.save} noToggleOnSave
                      preparedData={item} subpanels={subpanels} injects={selectInjects(this.props)} />
                  </td>
                </tr>}
              </Fragment>)}
              {this.state.statusNew && <tr>
                <td colSpan={collspan}>
                  <SHKFormTab
                    editPanel={subpanels[0]} onClose={this.toggleStatus}
                    onSave={this.save} noToggleOnSave
                    preparedData={{}} subpanels={subpanels} injects={selectInjects(this.props)} />
                </td>
              </tr>}
            </tbody>
          </table>}
          {!this.props.readonly && !disabled && !this.state.statusNew && <Button variant='outline-primary' className='w-100' onClick={this.getdIdAndToggle}>
            <Awesome name='plus' />&nbsp;Position hinzufügen
          </Button>}
        </Panel>
      </span>;
    }

    getIdAndDelete = ({ currentTarget }) => {
      const id = currentTarget.getAttribute("data-id");
      this.delete(id);
    };

    delete = async id => {
      const {
        onDelete,
        parentEntity,
        afterCommit,
      } = this.props;

      await onDelete(parentEntity, id, arrayinfo);
      afterCommit && afterCommit();
    };

    getdIdAndToggle = ({ currentTarget }) => {
      const id = currentTarget.getAttribute("data-id");
      this.toggleStatus(id);
    };

    toggleStatus = id => {
      if (id) {
        this.setState({ [id]: !this.state[id] });
      } else {
        this.setState({ statusNew: !this.state.statusNew });
      }
    };

    save = async entity => {
      const {
        onSave,
        afterSave,
        parentEntity,
        beforeSave,
      } = this.props;

      entity = _.isFunction(beforeSave) ? beforeSave(entity) : entity;

      if (!entity) {
        return;
      }

      await onSave(parentEntity, entity, arrayinfo);
      afterSave && afterSave(entity);
    };
  }

  let component = ContextWithPosition;
  _.forEach(decorators, d => {
    component = d(component);
  });

  return component;
}
